import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Profile from '@/views/Profile.vue'
import SiteMessages from '@/views/SiteMessages.vue'
// TODO: When removing authGuard replace with router.beforeEach call at the end of the router.
import { authGuard } from './auth/authGuard.js'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/products',
      name: 'products',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "products" */ './views/Products.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/tools',
      name: 'tools',
      component: () => import(/* webpackChunkName: "tools" */ './views/Tools.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/profile',
      name: 'profile',
      component: Profile,
      beforeEnter: authGuard,
    },
    {
      path: '/sitemessages',
      name: 'siteMessages',
      component: SiteMessages,
      // beforeEnter: authGuard,
    },
  ],
})
